import { JobExperience } from '../../../../models/JobExperience/JobExperience';
import { SchoolExperience } from '../../../../models/SchoolExperience/SchoolExperience';
import { Skill } from '../../../../models/Skills/Skills';

export const isSkillsAndCompetenciesFinished = (
    skills: Skill[] = [],
    schoolExperiences: SchoolExperience[] = [],
    jobExperiences: JobExperience[] = [],
): boolean => [skills.length, schoolExperiences.length, jobExperiences.length].every(Boolean);
